import { z } from 'zod';
import { imageSchema } from './image-schema';

export type TTrustFactor = z.infer<typeof trustFactorSchema>;

export const trustFactorSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    background: imageSchema,
  }),
});
